var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("questionnaire-view-section-group", {
        attrs: {
          response: _vm.response,
          model: _vm.roomTypesModel,
          template: _vm.getTemplate("RTD"),
        },
      }),
      _c("questionnaire-view-section-table", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.getTemplate("RT"),
        },
        on: { mounted: _vm.onSectionMounted },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }